/*
 * @Autor: 李建鹏
 * @Date: 2022-07-26 21:03:01
 * @LastEditTime: 2022-07-26 21:04:30
 * @Description: 性价比报告通用组件
 */
import CostPerformancePopup from './src/index'
CostPerformancePopup.install = function (Vue) {
  Vue.component(CostPerformancePopup.name, CostPerformancePopup)
}
export default CostPerformancePopup
